<!-- eslint-disable vue/attribute-hyphenation -->
<template>
    <div>
        <div v-if="ticketData" class="ticket-check__top">
            <ticket-compile-info :active="ticketData.actions.rebet.active"/>
            <table class="table">
                <ticket-header :data="ticketData"/>
                <ticket-body :data="ticketData"/>
                <ticket-status v-if="isWinOrLose()"
                               :data="ticketData"
                />
                <ticket-status v-else-if="isActiveTicket()"
                               :data="ticketData"
                />
                <ticket-lucky-loser v-if="ticketData.ticket.win.isLuckyLoser"/>
            </table>
        </div>
    </div>
</template>

<script>
    import TicketStatus from '@src/terminal/app/modules/checkTicket/TicketStatus';
    import TicketLuckyLoser from '@src/terminal/app/modules/checkTicket/TicketLuckyLoser';
    import TicketBody from '@src/terminal/app/modules/checkTicket/TicketBody';
    import TicketHeader from '@src/terminal/app/modules/checkTicket/TicketHeader';
    import TicketCompileInfo from '@src/terminal/app/modules/checkTicket/TicketCompileInfo';

    export default {
        name: 'TicketOverview',
        components: {
            TicketStatus,
            TicketLuckyLoser,
            TicketCompileInfo,
            TicketHeader,
            TicketBody
        },
        props: {
            ticketData: {
                required: true,
                type: Object
            }
        },
        computed: {
            parsedData() {
                return this.ticketData;
            }
        },
        methods: {
            isWinOrLose() {
                return this.parsedData.ticket.status === 'win' || this.parsedData.ticket.status === 'lost';
            },
            isActiveTicket() {
                return ['active', 'canceled'].includes(this.parsedData.ticket.status);
            }
        }
    };
</script>

<style>
.ticket-check__top {
    background: #242424;
    color: #fff;
}
.ticket-check__info {
    padding: 0.65rem;;
}
.info-message {
    font-size: 1.65rem;
    color: white;
    animation: info-keyframes 0.5s infinite;
}
.lotto-ball__container {
    display: flex;
    flex-direction: row;
}
.lotto-ball {
    text-align: center;
    width: 28px;
    height: 28px;
    border-radius: 28px;
    margin-right: 4px;
}
.win {
    background-color: green;
}
.lost {
    background-color: red;
}
.active {
    background-color: #242424;
}
.table {
    width: 100%;
    max-width: 100%;
    background: #242424;
    margin-bottom: 0.65rem;
    font-size: 1rem;
    line-height: 1.3;
    color: #fff;
    border-collapse: collapse;
    border-spacing: 0;
}
.table tbody {
    background-color: #242424;
}
.table .is--dark {
    background: rgba(0, 0, 0, 0.4);
}
.table thead, .table tbody, .table tfoot {
    border: none;
}
.table thead tr {
    color: #e6e6e6;
    border: 0;
}
td, th {
    padding: 0;
}
th {
    text-align: left;
}
.table th, .table td {
    line-height: 1.8;
    font-weight: 400;
    display: table-cell;
}
.table tbody td {
    color: #fff;
}
.table thead tr th {
    background-repeat: no-repeat;
    background-position: center;
}
.p-l-1 {
    padding-left: 0.65rem !important;
}
.p-y-1 {
    padding-top: 0.65rem !important;
    padding-bottom: 0.65rem !important;
}
.text-uppercase {
    text-transform: uppercase !important;
}
.results-number {
    display: inline-block;
    width: 2.5em;
    height: 2.5em;
    line-height: 2.5em;
    margin-top: 3px;
    margin-left: 4px;
    background: #424142;
    font-family: robotoRegular;
    color: #acacad;
    text-align: center;
    border-radius: 3px;
}
.results-number.active {
    background: #0066ae;
    color: #fff;
}
</style>`;



// WEBPACK FOOTER //
// src/terminal/app/modules/checkTicket/TicketOverview.vue